import Footer from "../components/footer/footer";
import Navigation from "../components/navigation/navigation";
import Section from "../components/section/section";

import "./impressum.scss";

function ImpressumPage() {
  return (
    <div className="main">
      <Navigation />

      <div className="stage-impressum">
        <h1 className="stage-impressum__headline">Impressum</h1>
      </div>

      <Section id="impressum">
        <h4 className="impressum__headline">Angaben gemäß § 5 TMG:</h4>
        Lennart Kallert
        <br />
        Gerstenbergstrasse 36
        <br />
        22609 Hamburg
        <br />
        Deutschland
        <br />
        <br />
        <h4 className="impressum__headline">Kontakt:</h4>
        Mobil: +49 176 / 44 27 88 26
        <br />
        E-Mail: contact@lennartkallert.de
        <br />
        LinkedIn: lennartkallert
        <br />
        <br />
        <h4 className="impressum__headline">Umsatzsteuer-ID:</h4>
        Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:
        DE285651759
        <br />
        <br />
        <h4 className="impressum__headline">
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
        </h4>
        Lennart Kallert
        <br />
        <br />
        <h4 className="impressum__headline">Haftungsausschluss:</h4>
        <h4 className="impressum__headline">Haftung für Inhalte</h4>
        <br />
        Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die
        Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich jedoch
        keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 7 Abs.1 TMG
        für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
        verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch
        nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen
        zu überwachen. Bei bekannt werden von Rechtsverletzungen werde ich diese
        Inhalte umgehend entfernen. Eine diesbezügliche Haftung übernehme ich
        erst ab dem Zeitpunkt der Kenntnis einer möglichen Rechtsverletzung.
        <br />
        <br />
        <h4 className="impressum__headline">Haftung für Links</h4>
        <br />
        Meine Website enthält Links zu externen Websites Dritter, auf deren
        Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei bekannt werden
        von Rechtsverletzungen werde ich derartige Links umgehend entfernen.
        <br />
        <br />
        <h4 className="impressum__headline">Urheberrecht</h4>
        Die durch mich erstellten Inhalte und Werke auf dieser Website
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechts bedürfen meiner schriftlichen Zustimmung.
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht
        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite
        nicht von mir erstellt wurden, werden die Urheberrechte Dritter
        beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
        Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
        bitte ich um einen entsprechenden Hinweis. Bei bekannt werden von
        Rechtsverletzungen werde ich derartige Inhalte umgehend entfernen.
        <br />
        <br />
        <h4 className="impressum__headline">Datenschutz</h4>
        Die Nutzung meiner Website ist in der Regel ohne Angabe
        personenbezogener Daten möglich. Soweit auf meiner Seite
        personenbezogene Daten (beispielsweise Name, Anschrift oder
        E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf
        freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
        Zustimmung nicht an Dritte weitergegeben. Ich weise darauf hin, dass die
        Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail)
        Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor
        dem Zugriff durch Dritte ist nicht möglich.
        <br />
        <br />
        <h4 className="impressum__headline">Widerspruch Werbe-Mails</h4>
        Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten
        Kontaktdaten zur Übersendung von nicht ausdrücklich angeforderter
        Werbung und Informationsmaterialien wird hiermit widersprochen. Der
        Betreiber der Seiten behält sich ausdrücklich rechtliche Schritte im
        Falle der unverlangten Zusendung von Werbeinformationen, etwa durch
        Spam-E-Mails, vor.
        <br />
        <br />
        <br />
        <br />
      </Section>

      <Footer />
    </div>
  );
}

export default ImpressumPage;
